var _path;

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

function SvgOutlined(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 24 24",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M 24 19 L 4 19 C 2.895 19 2 18.105 2 17 L 2 7 C 2 5.895 2.895 5 4 5 L 24 5 C 23.993 6.975 24.013 17.011 24 19 M 4 7 L 4 17 L 24 17 L 24 7 L 4 7"
  })), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "rgb(3, 3, 3)",
      fontFamily: "Roboto",
      fontSize: 7,
      whiteSpace: "pre"
    },
    x: 8.308,
    y: 14.615
  }, "Lab."));
}

const ForwardRef = /*#__PURE__*/React.forwardRef(SvgOutlined);
export default __webpack_public_path__ + "static/media/outlined.e899bf4d9733c0f5d1c8f6ea3e13967e.svg";
export { ForwardRef as ReactComponent };